import { render, staticRenderFns } from "./StudentReceipt.vue?vue&type=template&id=4b0358be&scoped=true"
import script from "./StudentReceipt.vue?vue&type=script&lang=js"
export * from "./StudentReceipt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0358be",
  null
  
)

export default component.exports